import { createSelector } from "reselect";

export const selectIsDistrictLoading = createSelector(
  (state) => state.pipe,
  (pipe) => pipe?.isDistrictLoading
);

export const selectDistrictList = createSelector(
  (state) => state.pipe,
  (pipe) => pipe?.districtList
);

export const selectIsFarmersGroupListLoading = createSelector(
  (state) => state.pipe,
  (pipe) => pipe?.isFarmersGroupListLoading
);

export const selectFarmerGroupList = createSelector(
  (state) => state.pipe,
  (pipe) => pipe?.farmersGroupList
);
export const selectIsFarmersGroupDetailsLoading = createSelector(
  (state) => state.pipe,
  (pipe) => pipe?.isFarmersGroupDetialsLoading
);

export const selectFarmerGroupDetails = createSelector(
  (state) => state.pipe,
  (pipe) => pipe?.farmersGroupDetails
);